<template>
<div class="spread df-col bg-background">
  <div class="bg-white header df-middle px-20">
    <Header />
  </div>
  <div class="flex-1 d-f m-10">
    <RouterView v-if="$route.meta.isBlank" name="blank" />
    <template v-else>
      <div class="section view">
        <RouterView #=" { Component, route }">
          <TransitionProvider :name="route.meta.transition">
            <KeepAlive :include="cacheList">
              <component :is="Component" />
            </KeepAlive>
          </TransitionProvider>
        </RouterView>
      </div>
      <div class="flex-1 df-col ml-10">
        <div class="section flex-1 d-f">
          <div class="view">
            <Market />
          </div>
          <div class="flex-1 chart p-r">
            <Symbol />
          </div>
        </div>
        <div class="section account mt-10">
          <Account />
        </div>
      </div>
    </template>
  </div>
</div>
<Popup />
</template>

<script lang="ts">
import { monitorGlobalEvents, ready, setupNewSession, switchLanguage } from '@/modules/app/app'
import Market from '@/modules/market/Market.index.vue'
import Symbol from '@/modules/market/Symbol.vue'
import Account from '@/views/Account.vue'
import Header from '@/views/Header.vue'
import TransitionProvider from '@/provider/TransitionProvider.vue'
import Popup from 'common/popout/Popup.vue'
import { computed, onMounted } from 'vue'
import { dynamicAliveList } from '@/features/dynamicAlive'
import { useRouter } from 'vue-router'

export default {
  components: { Account, Header, TransitionProvider, Symbol, Market, Popup },
  setup () {
    const router = useRouter()

    setupNewSession()

    monitorGlobalEvents()

    onMounted(() => {
      // 重置所有dialog产生的hashQuery
      // router.replace('/')

      switchLanguage().then(() => {
        ready(router)
      })
    })

    return {
      cacheList: computed(() => ['TabPage', 'CopyTrade', ...dynamicAliveList.value]),
    }
  },
}
</script>

<style scoped>
.header {
  min-height: 60px;
  border-bottom: 1px solid var(--color-border);
}

.section {
  border-radius: 6px;
  border: 1px solid var(--color-border);
  background: var(--color-white);
  overflow: hidden;
}

.view {
  position: relative;
  min-width: 370px;
  overflow: hidden;
}

.account {
  min-height: 320px;
}

.chart {
  border-left: 1px solid var(--color-border);
}
</style>
